module.exports = __webpack_public_path__ + "img/mouse.fc72b03b.png";